var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"frame",attrs:{"src":"https://forms.yandex.ru/u/627136497b0a1bc44aeef9d1/?iframe=1","frameborder":"0","width":"520","name":"ya-form-627136497b0a1bc44aeef9d1"}})}
var staticRenderFns = []

export { render, staticRenderFns }